<template>
  <li
    :id="`tab_${tab.id}`"
    :key="tab.id"
    v-tooltip="tab.disabled ? tab.disabledTooltip : null"
    :class="active ? 'active' : ''"
    :disabled="tab?.disabled"
    @click="() => onTabClicked()">
    <div
      v-if="tab.icon != null"
      class="icon-wrapper">
      <component :is="tab.icon" />
      <div
        v-show="tab.count > 0"
        class="icon-badge">
        <div>{{ tab.count }}</div>
      </div>
    </div>
    <span>{{ tab.title }}</span>
    <slot
      name="icon-wrapper-right"
      :tab-id="tab.id" />
  </li>
</template>

<script setup lang="ts">
  import { Tab } from '@/org-app/components/controls/TabList.vue';

  const { tab, active } = defineProps<{ tab: Tab; active: boolean }>();

  function onTabClicked() {
    if (tab.disabled) {
      return;
    }
    emit('tabClicked');
  }

  const emit = defineEmits(['tabClicked']);
</script>

<style lang="scss" scoped>
  li {
    color: var(--textColor);
    border-bottom: 0.4rem solid transparent;
    text-transform: uppercase;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-bottom: 1rem;
    transition: all 0.2s ease-in-out;
    font-weight: 600;

    svg {
      position: relative;
      width: 2.4rem;
      height: 2.4rem;
      margin-right: 0.6rem;
    }

    &.active {
      border-bottom-color: var(--secondaryColor);
      color: var(--textColor);
    }

    &[disabled='true'] {
      cursor: not-allowed;
      color: var(--textMutedColor);
    }
  }
</style>
